import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useHistory, useLocation } from 'react-router-dom';
import Markdown from 'markdown-to-jsx';
import { Grid, Cell, Heading, Flex } from '@phishtool/ui';
import Pattern from '../pattern';
import ContentWrapper, { ContentWrapperInner, ContentBox } from '~components/content-wrapper';
import { StyledSelect, StyledContentWrapper } from './styled';
const options = [
    {
        label: 'Terms of Service',
        value: '/terms-of-service',
    },
    {
        label: 'Privacy Policy',
        value: '/privacy-policy',
    },
    {
        label: 'Proof of Value Agreement',
        value: '/proof-of-value-agreement',
    },
    {
        label: 'Service Agreement',
        value: '/service-agreement',
    },
];
const Legal = ({ heading, content }) => {
    const history = useHistory();
    const location = useLocation();
    return (_jsxs(ContentWrapper, { children: [_jsx(Pattern, {}), _jsxs(ContentWrapperInner, { children: [_jsxs(Grid, Object.assign({ spacer: "xxl", rowGap: "xxl" }, { children: [_jsx(Cell, Object.assign({ order: [2, 1], start: [1, null, 2], end: [13, 8] }, { children: _jsx(Heading, Object.assign({ spacer: "none" }, { children: heading })) })), _jsx(Cell, Object.assign({ order: [1, 2], start: [1, 8], end: [13, null, 12] }, { children: _jsx(Flex, Object.assign({ height: "100%", justify: "flex-end", align: "center" }, { children: _jsx(StyledSelect, Object.assign({ defaultValue: location.pathname, onChange: (e) => history.push(e.target.value) }, { children: options.map(({ label, value }) => (_jsx("option", Object.assign({ value: value }, { children: label }), value))) })) })) }))] })), _jsx(Grid, { children: _jsx(Cell, Object.assign({ start: [1, null, 2], end: [13, null, 12] }, { children: _jsx(ContentBox, { children: _jsx(StyledContentWrapper, { children: _jsx(Markdown, { children: content }) }) }) })) })] })] }));
};
export default Legal;
